// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pop-set-express .radio-group {\n  padding: 10px 0  0;\n}\n.pop-set-express .radio-group .el-radio {\n    line-height: 32px;\n    display: block;\n}\n.pop-set-express .radio-group .el-radio__label {\n    font-size: 12px;\n    font-weight: normal;\n    padding-left: 3px;\n    color: #333;\n}\n", ""]);
// Exports
module.exports = exports;
